// app/javascript/controllers/dropdown_controller.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
  }

  toggle(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle('is-active');
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.remove('is-active');
    }
  }
}
